import { Inject, Injectable } from '@angular/core';
import * as angular from 'angular';
import { lodash } from '../ajs-upgraded-providers';
import { AppSettingsService } from '../appSettings/AppSettingsService';
import { ISearchHistoryService } from '../config/typings/services';
import { ProxyService } from '../proxy/ProxyService';

@Injectable({
    providedIn: 'root'
})
export class SearchHistoryService implements ISearchHistoryService {
    public static $name: string = 'searchHistoryService';

    constructor(
        private appSettingsService: AppSettingsService,
        @Inject(lodash) private lodash: _.LoDashStatic,
        private proxyService: ProxyService
    ) {
    }

    public getSearchHistory(): CASLink.Device.Ui.ViewModel.Modules.LocationSearchResultViewModel[] {
        const metadata = this.appSettingsService.getMetadata();

        return metadata && metadata.searchHistory ? metadata.searchHistory : [];
    }

    public storeSelectedModule(module: CASLink.Device.Ui.ViewModel.Modules.LocationSearchResultViewModel) {
        // Work on a copy so we don't have to worry about references
        const moduleCopy = angular.copy(module);

        this.sanitizeModule(moduleCopy);
        this.addModuleToList(moduleCopy, this.getSearchHistory());
        this.persistSelectedModule(moduleCopy);
    }

    private persistSelectedModule(module: CASLink.Device.Ui.ViewModel.Modules.LocationSearchResultViewModel) {
        this.proxyService.request({
            data: {
                Entity: {
                    LocationId: module.locationId,
                    ModuleId: module.id
                }
            },
            endPoint: 'userSearchHistory',
            route: 'updateUserSearchHistory'
        }).asNoContent();
    }

    private addModuleToList(module: CASLink.Device.Ui.ViewModel.Modules.LocationSearchResultViewModel, list: any[]) {
        const maxListLength = 10;

        if (list.length >= maxListLength) {
            list.shift();
        }

        this.lodash.remove(list, m => {
            // Double equals on purpose since sometimes one will end up being a string and the other a number

            // tslint:disable-next-line: triple-equals
            const matchesModule = module.id && module.id == m.id;
            // tslint:disable-next-line: triple-equals
            const matchesLocation = module.locationId && module.locationId == m.locationId;

            return matchesModule || matchesLocation;
        });

        list.unshift(module);
    }

    /**
     * We don't want to store the same location multiple times because the user loaded associated modules directly.
     * Therefore, we should strip the moduleId if the locationId was present
     */
    private sanitizeModule(module: CASLink.Device.Ui.ViewModel.Modules.LocationSearchResultViewModel) {
        if (module.locationId) {
            module.id = null;
        }
    }
}
